/**
 * ListContainer Component.js
 * The container for the ListItem component.
 *
 * @class   ListContainer
 * @author  Yevgeniy Rokhlin
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import fuzzy from 'fuzzy';

// Components
import Divider from 'components/divider/Divider';
import ListItem from 'components/list/ListItem';

export default React.createClass({

	displayName: "ListContainer",

	propTypes: {
		direction: React.PropTypes.oneOf(['row','column']),
		divided: React.PropTypes.bool,
		filter: React.PropTypes.string,
		customListItemType: React.PropTypes.node
	},

	defaultProps() {
		return {
			direction: 'column',
			divided: false,
			customListItemType: null
		}
	},

	render() {

		let { direction, wrap, divided, children, customListItemType } = this.props;

		// Assign class based on "direction" prop
		let classes = ClassNames( this.props.className, {
			'lui-list-container-direction-column': direction === 'column',
			'lui-list-container-direction-row': direction === 'row',
		});

		let filteredChildren = [];
		
		if (this.props.filter){
			React.Children.forEach(children, (child, i)=>{
				if (React.addons.TestUtils.isElementOfType(child, customListItemType ? customListItemType : ListItem)){
					
					let result = fuzzy.filter(this.props.filter, this.formatMeta(child.props.meta)).map(function(res) {
						return res.original;
					});

					if (result.length > 0) {
						filteredChildren.push(child)
					}

				}
			});
		} else {
			filteredChildren = children;
		}
		
		if(divided && React.Children.count(filteredChildren) > 1) {
			filteredChildren = React.Children.map(filteredChildren, (child, i) => {
				// Don't add divider to last list item
				if(i < React.Children.count(filteredChildren)) {
					return (
						<div key={i} >
							{child}
							<Divider marginTop={0} marginBottom={0} />
						</div>
					);
				}
			});
		}

		return (
			<ul id="lui-list-container" className={classes} >
				{filteredChildren}
			</ul>
		);
	},

	formatMeta(meta) {

		if(Array.isArray(meta)) return meta;

		let arr = [];

		for(let key in meta) {

			arr.push(meta[key].toString());

		};

		return arr;
	},

});



/** WEBPACK FOOTER **
 ** ./src/components/list/ListContainer.js
 **/